export const mockColleagues = [
  {
    id: '1',
    name: 'Dr. Sarah Chen',
    avatar: 'https://storage.googleapis.com/kiprweb/assets/7.jpg',
    availability: 'coming_soon' as const,
    title: 'Senior BCBA',
    organization: 'Behavioral Health Center',
    specialty: 'Autism Spectrum Disorders',
    personality: 'Evidence-based and methodical',
    communicationStyle: 'Professional and collaborative, focuses on data-driven decisions. Appreciates detailed case discussions and peer consultation.',
    expertise: ['Functional Behavior Assessment', 'Intervention Design', 'Staff Training', 'Research Methods'],
    workingSince: '2018',
    backgroundInfo: 'Board Certified Behavior Analyst with 6+ years experience. Specializes in complex cases and mentoring junior therapists.',
    preferredCommunication: 'Structured meetings with agenda and follow-up documentation'
  },
  {
    id: '2',
    name: 'Marcus Williams',
    avatar: 'https://storage.googleapis.com/kiprweb/assets/8.jpg',
    availability: 'coming_soon' as const,
    title: 'Insurance Case Manager',
    organization: 'HealthFirst Insurance',
    specialty: 'ABA Coverage Authorization',
    personality: 'Detail-oriented and process-focused',
    communicationStyle: 'Formal and documentation-heavy. Requires specific terminology and evidence-based justifications for continued coverage.',
    expertise: ['Coverage Guidelines', 'Treatment Authorization', 'Progress Documentation', 'Cost-Benefit Analysis'],
    workingSince: '2020',
    backgroundInfo: 'Former special education teacher turned insurance professional. Understands both clinical and administrative perspectives.',
    preferredCommunication: 'Written reports with clear metrics and outcome data'
  },
  {
    id: '3',
    name: 'Lisa Park',
    avatar: 'https://storage.googleapis.com/kiprweb/assets/5.jpg',
    availability: 'coming_soon' as const,
    title: 'School Psychologist',
    organization: 'Riverside Elementary School',
    specialty: 'Educational Psychology',
    personality: 'Collaborative and student-focused',
    communicationStyle: 'Warm but professional, focuses on practical classroom applications. Values input from all team members.',
    expertise: ['IEP Development', 'Classroom Interventions', 'Academic Assessment', 'Transition Planning'],
    workingSince: '2016',
    backgroundInfo: 'School psychologist working closely with ABA teams to ensure consistency between home and school interventions.',
    preferredCommunication: 'Regular check-ins with practical examples and classroom observations'
  },
  {
    id: '4',
    name: 'Dr. James Rodriguez',
    avatar: 'https://storage.googleapis.com/kiprweb/assets/9.jpg',
    availability: 'coming_soon' as const,
    title: 'Pediatric Neurologist',
    organization: 'Children\'s Medical Center',
    specialty: 'Neurodevelopmental Disorders',
    personality: 'Clinical and research-oriented',
    communicationStyle: 'Medical terminology focused, appreciates concise updates on behavioral progress as it relates to neurological development.',
    expertise: ['Neurological Assessment', 'Medication Management', 'Developmental Milestones', 'Medical Coordination'],
    workingSince: '2015',
    backgroundInfo: 'Pediatric neurologist who works with ABA teams to coordinate comprehensive care for children with complex needs.',
    preferredCommunication: 'Brief, clinical updates with focus on measurable behavioral changes'
  }
];